(() => {
  'use strict';
  const RECENTS_KEY = 'ottrecord-beat-recents-v1';
  const rememberBeat = (id) => {
    if (!id) return;
    try {
      const raw = JSON.parse(localStorage.getItem(RECENTS_KEY) || '[]');
      const items = Array.isArray(raw) ? raw.map(String).filter(Boolean) : [];
      localStorage.setItem(RECENTS_KEY, JSON.stringify([String(id), ...items.filter((item) => item !== String(id))].slice(0, 8)));
    } catch (_error) {}
  };
  const updateCartCount = async () => {
    try {
      const cart = await window.OTTBeatCommerce?.getCart?.();
      if (!cart) return;
      document.querySelectorAll('a[href*="/cart"]').forEach((link) => {
        const badge = link.querySelector('[data-cart-count], .cart-count-bubble, .ott-cart-count');
        if (badge) badge.textContent = String(cart.item_count);
      });
    } catch (_error) {}
  };
  const boot = (scope = document) => {
    const sections = [];
    if (scope instanceof Element && scope.matches('[data-ott-product-beat]')) sections.push(scope);
    if (scope.querySelectorAll) sections.push(...scope.querySelectorAll('[data-ott-product-beat]'));
    sections.forEach((section) => {
      if (section.dataset.ottV1StockReady === 'true') return;
      section.dataset.ottV1StockReady = 'true';
      rememberBeat(section.dataset.productId || '');
      section.addEventListener('click', (event) => { if (event.target.closest('[data-ott-play]')) rememberBeat(section.dataset.productId || ''); });

      let productTranslations = {};
      try { productTranslations = JSON.parse(document.querySelector('[data-ott-product-i18n]')?.textContent || '{}'); } catch (_error) {}
      const txt = (key, fallback) => productTranslations[key] || fallback;
      const form = section.querySelector('[data-ott-beat-purchase-form]');
      if (!form) return;
      const radios = [...form.querySelectorAll('[data-formula-radio]')];
      const titles = [...section.querySelectorAll('[data-variant-title]')];
      const prices = [...section.querySelectorAll('[data-variant-price]')];
      const stemsNodes = [...section.querySelectorAll('[data-stems-status]')];
      const delivery = section.querySelector('[data-delivery-summary]');
      const button = form.querySelector('[data-add-button]');
      const message = form.querySelector('[data-purchase-message]');

      const refresh = (radio) => {
        if (!radio) return;
        const withStems = radio.dataset.stems === 'true';
        titles.forEach((node) => { node.textContent = radio.dataset.title || 'Licence'; });
        prices.forEach((node) => { node.textContent = radio.dataset.price || ''; });
        stemsNodes.forEach((node) => { node.textContent = withStems ? txt('included','Inclus') : txt('not_included','Non inclus dans cette formule'); });
        if (delivery) delivery.textContent = withStems ? txt('delivery_stems','Fichier audio, licence et stems multipistes selon la commande.') : txt('delivery_standard','Fichier audio numérique et cadre de licence lié à la commande.');
        if (button && !button.disabled) {
          const label = `${txt('add','Ajouter')} · ${radio.dataset.price || ''}`.trim();
          button.textContent = label;
          button.setAttribute('aria-label', label);
        }
      };
      radios.forEach((radio) => radio.addEventListener('change', () => refresh(radio)));
      refresh(radios.find((radio) => radio.checked) || radios[0]);

      form.addEventListener('submit', async (event) => {
        const selected = radios.find((radio) => radio.checked && !radio.disabled);
        if (!selected || !button) {
          event.preventDefault();
          return;
        }
        if (!window.OTTBeatCommerce?.addFormula) {
          if (selected.dataset.stems === 'true') {
            event.preventDefault();
            if (message) message.textContent = txt('addon_reload','Le module Stems doit être rechargé. La formule standard reste achetable immédiatement.');
            return;
          }
          button.disabled = true;
          button.textContent = txt('redirect','Redirection sécurisée…');
          return;
        }
        event.preventDefault();
        const original = button.textContent;
        button.disabled = true;
        button.textContent = txt('adding','Ajout sécurisé…');
        if (message) message.textContent = txt('stock_check','Vérification du stock exclusif…');
        try {
          await window.OTTBeatCommerce.addFormula({
            baseVariantId: form.dataset.baseVariantId,
            addonVariantId: form.dataset.addonVariantId,
            withStems: selected.dataset.stems === 'true',
            productId: form.dataset.productId,
            productHandle: form.dataset.productHandle,
            beatTitle: form.dataset.productTitle
          });
          await updateCartCount();
          button.textContent = txt('added','Ajouté ✓');
          if (message) message.textContent = selected.dataset.stems === 'true' ? txt('success_stems','Beat + stems ajoutés. Une seule unité du beat reste comptée.') : txt('success_standard','Beat ajouté. Le stock exclusif est protégé.');
          window.dispatchEvent(new CustomEvent('ottrecord:cart:add-success', { detail: { product_id: form.dataset.productId || '', variant_id: form.dataset.baseVariantId || '', item_type: 'beat', source: 'product-stock-unique' } }));
          window.setTimeout(() => { window.location.href = `${window.Shopify?.routes?.root || '/'}cart`; }, 450);
        } catch (error) {
          button.disabled = false;
          button.textContent = original;
          const cartReviewRequired = String(error?.message || '').includes('cart-review-required');
          if (message) message.textContent = cartReviewRequired
            ? txt('cart_review', 'Le panier doit être vérifié. Contrôle le beat et les stems dans ton panier avant de réessayer.')
            : error?.message?.includes('sold')
              ? txt('sold', 'Cette instrumentale vient d’être vendue.')
              : txt('error', 'Ajout impossible pour le moment. Recharge la page avant de réessayer.');
          console.error('[OTTRecord V1 stock unique]', error);
        }
      });
    });
  };
  boot(document);
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('ott:navigation:complete', () => boot(document));
})();
